import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import HomePage from './view/HomePage';
import Header from './component/common/Header';
import Footer from './component/common/Footer';
import AdListingPage from './view/AdListingPage';
import ContactUs from './component/contactUs/ContactUs';
import PrivacyPolicy from './component/privacyPolicy/PrivacyPolicy';
import TermsAndCondition from './component/termsAndCondition/TermsAndConditon';
import RefundAndCancellation from './component/refundAndCancellation/RefundAndCancellation';
import AdDetailsPage from './view/AdDetailsPage';
import NotFound from './view/NotFound';
import MobileAppLink from './component/mobile-app-link/MobileAppLink';
import BlogListingPage from './view/BlogListingPage';
import BlogPage from './view/BlogPage';
import PlanPage from './view/PlanPage';
import AboutPage from './view/AboutPage';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './view/LoginPage';
import SignUpPage from './view/SignUpPage';
import ProfilePage from './view/customer/ProfilePage';
import ListingPage from './view/customer/ListingPage';
import LeadsPage from './view/customer/LeadsPage';

const scrollToTop = () => {
  window.scroll(0,0)
}


function App() {
  return (
    <div className="App">
      <AuthProvider>
            <Router>
              <Header />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/home" element={<Navigate to="/" replace />} />
                    <Route path="/plans" element={<PlanPage />} />
                    <Route path="/Service-Near-Me/:subcategory/:searchlocation" element={<AdListingPage />} />
                    <Route path="/Service-Near-Me/:subcategory" element={<AdListingPage />} />
                    <Route path="/details/:adId/:CompanyName/:searchlocation" element={<AdDetailsPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/app" element={<MobileAppLink />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                    <Route path="/termsandcondition" element={<TermsAndCondition />} />
                    <Route path="/refundandcancellation" element={<RefundAndCancellation />} />
                    <Route path="/blogs" element={<BlogListingPage />} />
                    <Route path="/blog/:blogTitle" element={<BlogPage />} />
                    <Route path="*" element={<NotFound />} />                        
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignUpPage />} />                                            
                    <Route path="/customer-profile" element={<ProfilePage />} />                                            
                    <Route path="/listings" element={<ListingPage />} />                                        
                    <Route path="/leads/:adId?" element={<LeadsPage />} />
                </Routes>
            </Router>
    </AuthProvider>
    
    <button className="scrolltop" onClick={()=>scrollToTop()}><i className="fas fa-arrow-up" title="Scroll To Top"></i></button>
    
    <Footer />
    </div>
  );
}

export default App;
